export default "__VITE_PUBLIC_ASSET__806c671a__"